
<template>
    <keep-alive>
        <Main />
    </keep-alive>
</template>




<script>
    import index from './index';
    // import p_index from './p_index';
    // import m_index from './m_index'
    import Main from './main'
    export default {
        ...index,
        components :{
            Main
        }
    }

</script>